<script setup lang="ts">
definePage({
  meta: {
    allowAnonymous: true,
    layout: 'auth',
  },
})

const router = useRouter()
</script>

<template>
  <AuthLayoutCard>
    <template #title>
      404 - Pagina niet gevonden
    </template>

    <template #message>
      Het lijkt erop dat de pagina die je zoekt niet bestaat. Check de URL of ga terug naar de startpagina.
    </template>

    <Button label="Terug naar startpagina" @click="() => router.push('/')" rounded />
  </AuthLayoutCard>
</template>
